import React from "react";

import type { TerritorialStatusKind } from "./territorialStatus";

const STATUS_COLORS: Record<TerritorialStatusKind, string> = {
  red: "#F44336",
  orange: "#FF9800",
  green: "#4CAF50",
  blue: "#2196F3",
  purple: "#9C27B0",
};

export const TerritorialStatusIndicator = ({
  status,
}: {
  status: TerritorialStatusKind;
}) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    aria-label="Статус"
    style={{ flexShrink: 0 }}
  >
    <circle cx="6" cy="6" r="6" fill={STATUS_COLORS[status]} />
  </svg>
);
